<details class="mt-2" data-testid="debug-menu-section">
  <summary class="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-base-200 transition-colors select-none text-sm text-base-content/70">
    <app-icon name="build" size="sm" class="text-warning"></app-icon>
    <span class="font-medium">Debug Tools</span>
    @if (debug.isAnyEnabled()) {
      <span class="badge badge-warning badge-xs ml-auto">ON</span>
    }
  </summary>

  <div class="pl-2 pr-1 pb-2 space-y-2 mt-1">
    <!-- Master Toggle -->
    <label class="flex items-center justify-between p-2 rounded-lg bg-warning/10 border border-warning/20 cursor-pointer" data-testid="debug-menu-master-toggle">
      <span class="text-sm font-semibold text-warning">All Features</span>
      <input
        type="checkbox"
        class="toggle toggle-sm toggle-warning"
        [checked]="debug.allEnabled()"
        (change)="onMasterToggle()"
      />
    </label>

    <!-- Individual Toggles -->
    @for (item of toggles; track item.flag) {
      <label class="flex items-center justify-between p-1.5 rounded hover:bg-base-200 cursor-pointer" [attr.data-testid]="'debug-menu-toggle-' + item.flag">
        <div class="min-w-0">
          <div class="text-sm font-medium">{{ item.label }}</div>
          <div class="text-xs text-base-content/50 truncate">{{ item.description }}</div>
        </div>
        <input
          type="checkbox"
          class="toggle toggle-xs toggle-primary ml-2 flex-shrink-0"
          [checked]="debug.isEnabled(item.flag)"
          (change)="onToggle(item.flag)"
        />
      </label>
    }

    <!-- Org Context Info (shown when orgContext flag enabled) -->
    @if (debug.isEnabled('orgContext')) {
      <div class="p-2 bg-info/10 rounded-lg border border-info/20 text-xs font-mono" data-testid="debug-menu-org-info">
        <div class="font-semibold text-info mb-1">Org Context</div>
        <div class="text-base-content/70">Name: {{ currentOrgName }}</div>
        <div class="text-base-content/70">ID: {{ currentOrgId | slice:0:8 }}...</div>
      </div>
    }
  </div>
</details>
